import { combineReducers } from 'redux';
import signInReducer from './signIn';
import getCategoriesReducer from './getCategories';
import getSubcategoriesReducer from './getSubcategories';
import getUserReducer from './getUser';
import getUsersReducer from './getUsers';
import getQuestionsReducer from './getQuestions';
import globalReducer from './global';
import getGameManagementReducer from './getGameManagement';
import getShowsReducer from './getShows';
import getEntityReducer from './getEntity';

export default combineReducers({
    global: globalReducer,
    signIn: signInReducer,
    categories: getCategoriesReducer,
    subcategories: getSubcategoriesReducer,
    user: getUserReducer,
    users: getUsersReducer,
    questions: getQuestionsReducer,
    gameManagement: getGameManagementReducer,
    getShows: getShowsReducer,
    getEntity: getEntityReducer,
});
